import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'

import { getBookingURL } from '../utils/Utils'
import type { EventApiItem } from './EventTicketButton'

type EventsByDate = Record<string, EventApiItem[]>

interface PricingTableProps {
  data?: {
    eventType?: string
  }
}

const PricingTable = ({ data }: PricingTableProps) => {
  const [events, setEvents] = useState<EventsByDate>({})
  const jsProps = window.jsProps

  const eventType = useMemo(() => data?.eventType ?? '', [data])

  useEffect(() => {
    moment.locale(jsProps.lang)

    fetch(
      `https://api.miniatur-wunderland.de/v1/events/${moment().format('YYYY-MM-DD')}/next3/${eventType}/`,
      { method: 'GET', mode: 'cors' },
    )
      .then((response) => response.json())
      .then((data: EventApiItem[]) => {
        const eventsByDate = data.reduce<EventsByDate>((prev, next) => {
          if (!(next.datum in prev)) {
            prev[next.datum] = []
          }
          prev[next.datum].push(next)
          return prev
        }, {})

        setEvents(eventsByDate)
      })
      .catch((e) => {
        console.warn(e)
      })
  }, [eventType])

  return (
    <div>
      {/* Desktop Layout */}
      <div className="col-md-12 hidden-xs hidden-sm">
        <div className="PricingTable">
          <table className="TableElement__Table">
            <thead className="TableElement__TableHeader Text Text--first-copy">
              <tr>
                <th style={{ width: '40%' }}>{jsProps.strings.dayOfEvent}</th>
                <th style={{ width: '30%' }}>
                  {jsProps.strings.availableTimes}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(events).map((date) => {
                const eventsForDate = events[date]
                return (
                  <tr key={date} className="TableElement__TableRow">
                    <td style={{ verticalAlign: 'middle' }}>
                      {moment(date, 'YYYY-MM-DD').format('dddd, D. MMMM YYYY')}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {eventsForDate.map((event, index) => {
                        if (event.ticketAvailible) {
                          return (
                            <span key={index}>
                              {event.from}
                              {index < eventsForDate.length - 1 && (
                                <span> / </span>
                              )}
                            </span>
                          )
                        }
                        return null
                      })}
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                      <a
                        href={getBookingURL(date, true)}
                        className="Cta Cta--icon Cta--icon-ticket"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {jsProps.strings.book}
                      </a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="col-xs-12 visible-xs visible-sm">
        <div className="PricingTable">
          {Object.keys(events).map((date) => {
            const eventsForDate = events[date]
            return (
              <table key={date} className="TableElement__Table">
                <tbody>
                  <tr className="TableElement__TableRow">
                    <td width="40%">{jsProps.strings.dayOfEvent}</td>
                    <td>
                      {moment(date, 'YYYY-MM-DD').format('dddd, D. MMMM YYYY')}
                    </td>
                  </tr>
                  <tr className="TableElement__TableRow">
                    <td width="40%">{jsProps.strings.availableTimes}</td>
                    <td>
                      {eventsForDate.map((event, index) => {
                        if (event.ticketAvailible) {
                          return (
                            <span key={index}>
                              {event.from}
                              {index < eventsForDate.length - 1 && (
                                <span> / </span>
                              )}
                            </span>
                          )
                        }
                        return null
                      })}
                    </td>
                  </tr>
                  <tr className="TableElement__TableRow">
                    <td width="40%"></td>
                    <td>
                      <a
                        href={getBookingURL(date, true)}
                        className="Cta Cta--icon Cta--icon-ticket"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {jsProps.strings.book}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = () => ({})

function mapDispatchToProps(_dispatch: unknown) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PricingTable)
